import { Modal } from '@safetyhub/ui';

type ShortcutsModalProps = {
  open: boolean;
  onClose: () => void;
};

const SHORTCUTS: { category: string; items: { keys: string; desc: string }[] }[] = [
  {
    category: '편집 · 이력',
    items: [
      { keys: 'Ctrl/⌘ + Z', desc: '실행 취소' },
      { keys: 'Ctrl/⌘ + Shift + Z  ·  Ctrl + Y', desc: '다시 실행' },
      { keys: 'Ctrl/⌘ + S', desc: '저장' },
      { keys: 'Ctrl/⌘ + D', desc: '선택 노드 복제' },
      { keys: 'Ctrl/⌘ + C', desc: '선택 노드 복사' },
      { keys: 'Ctrl/⌘ + V', desc: '노드 붙여넣기' },
      { keys: 'Ctrl/⌘ + B', desc: '선택한 텍스트/셀 굵게 토글' },
      { keys: 'Ctrl/⌘ + M', desc: '셀 병합/해제 (다중 선택→병합, 병합 셀→해제)' },
      { keys: 'Delete · Backspace', desc: '선택 노드 삭제' },
      { keys: 'Esc', desc: '선택 해제 / 컨텍스트 상위 복귀(단계별) / 인라인 편집 종료' },
      { keys: 'Ctrl/⌘ + Shift + B', desc: '시뮬레이션 열기 (저장된 템플릿 기준, 새 탭)' },
      {
        keys: 'Ctrl/⌘ + K',
        desc: '양식 탐색기 펼치기 + 검색 포커스 (탐색기 안에서 Esc = 접기, 클릭 = 열기, Ctrl/Shift + 클릭 = 다중 선택)',
      },
      { keys: 'F1', desc: '단축키 목록 열기' },
      { keys: 'F4', desc: '작성 페이지 ↔ 보고서 탭 전환' },
      { keys: 'F8', desc: '새 창 미리보기 열기' },
      {
        keys: 'F9',
        desc: '분기 관계 연결선 표시/숨김 (보고서 탭 — 슬롯 탭에서 그 안 중첩 분기로 선. Esc로도 닫힘)',
      },
    ],
  },
  {
    category: '작성 페이지 탭',
    items: [
      {
        keys: 'Alt + 1 / 2 / 3',
        desc: '반응형 뷰 전환 (데스크톱 / 폴드형 / 바형 — 뷰 목록 순서)',
      },
      { keys: 'Ctrl/⌘ + 클릭', desc: '위젯 다중 선택 토글(섹션 넘어 가능 — 조상·자손 동시 선택만 제외)' },
      { keys: 'Delete · Backspace', desc: '선택 위젯 배치 철회(입력) / 삭제(섹션·디자인)' },
      {
        keys: 'Ctrl/⌘ + B',
        desc: '선택 위젯 문자열 굵게 토글(제목 텍스트 · 입력 라벨 · 섹션 제목) / 표 셀 선택 중엔 셀 굵게',
      },
      {
        keys: 'Ctrl/⌘ + G',
        desc: '다중 선택 위젯을 새 섹션으로 묶기 — 선택에 섹션이 1개 포함돼 있으면 나머지 위젯을 그 섹션에 포함',
      },
      { keys: 'Ctrl/⌘ + Shift + G', desc: '선택 섹션 해제' },
      { keys: 'Ctrl/⌘ + Enter', desc: '표 셀 선택 중 — 선택 셀 아래 행 추가' },
      { keys: 'Ctrl/⌘ + Delete', desc: '표 셀 선택 중 — 선택 셀의 행/열 삭제 (모달 선택)' },
      { keys: '↑ ↓ ← →', desc: '표 셀 선택 중 — 셀 간 이동(병합 건너뜀)' },
      { keys: 'Shift + ↑↓←→', desc: '표 셀 선택 중 — 직사각 범위 확장' },
      { keys: 'Tab · Shift + Tab', desc: '위젯 선택 중 — 다음 · 이전 위젯으로 이동(트리 순서 순환)' },
      { keys: 'Tab · Shift + Tab', desc: '표 셀 선택·편집 중 — 다음 · 이전 셀(행 우선 순환, 편집 중엔 커밋 후 이동한 셀 편집 유지)' },
      { keys: 'Ctrl/⌘ + A', desc: '표 셀 선택 중 — 표 전체 셀 선택' },
      { keys: 'F2', desc: '표 셀 선택 중 — 셀 편집 진입(컨트롤 포커스 · 텍스트 셀 인라인 편집)' },
      {
        keys: 'F2',
        desc: '위젯 선택 중(표 셀 미선택) — 트리 행 라벨 이름 변경(텍스트 · 입력 라벨만, 트리 행 더블클릭과 동일)',
      },
      { keys: 'Ctrl/⌘ + M', desc: '표 셀 선택 중 — 셀 병합(직사각 복수) / 해제(병합 셀 단일)' },
      { keys: 'Esc', desc: '위젯 선택 해제' },
    ],
  },
  {
    category: '노드 순서 · 그룹',
    items: [
      { keys: '↑', desc: '선택 노드 위로 이동' },
      { keys: '↓', desc: '선택 노드 아래로 이동' },
      { keys: 'Tab · Shift + Tab', desc: '같은 부모 안 형제 순환 선택' },
      { keys: 'Ctrl/⌘ + G', desc: '다중 선택(2개 이상) 노드를 그룹으로 묶기' },
      { keys: 'Ctrl/⌘ + Shift + G', desc: '선택 그룹/스택 해제' },
    ],
  },
  {
    category: '줌 · 팬',
    items: [
      { keys: 'Ctrl + 휠', desc: '커서 기준 확대/축소' },
      { keys: 'Ctrl/⌘ + = (또는 +)', desc: '줌 인' },
      { keys: 'Ctrl/⌘ + - (또는 _)', desc: '줌 아웃' },
      { keys: 'Ctrl/⌘ + 0', desc: '줌 리셋' },
      { keys: 'Space (누른 채 드래그)', desc: '팬(이동)' },
    ],
  },
  {
    category: '인라인 텍스트 편집',
    items: [
      { keys: 'Enter', desc: '커밋' },
      { keys: 'Shift + Enter', desc: '줄바꿈' },
      { keys: 'Esc', desc: '취소' },
    ],
  },
  {
    category: '셀 선택 · 이동',
    items: [
      { keys: 'Ctrl/⌘ + A', desc: '현재 표의 전체 셀 선택' },
      { keys: 'Shift + 클릭', desc: '직사각 범위 선택' },
      { keys: 'Ctrl/⌘ + 클릭', desc: '셀 토글 선택' },
      { keys: '↑ ↓ ← →', desc: '셀 간 이동(병합 건너뜀)' },
      { keys: 'Shift + ↑↓←→', desc: '직사각 범위 확장' },
      { keys: 'F2', desc: '선택 셀 편집 진입' },
      { keys: 'Delete · Backspace', desc: '선택 셀 내용 지우기(서식 유지)' },
      { keys: 'Ctrl/⌘ + Enter', desc: '선택 셀 아래 행 추가' },
      { keys: 'Ctrl/⌘ + Delete', desc: '선택 셀의 행/열 삭제 (모달 선택)' },
      { keys: 'Tab · Shift + Tab', desc: '편집 중 다음 · 이전 셀 선택' },
    ],
  },
];

export function ShortcutsModal({ open, onClose }: ShortcutsModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="⌨ 단축키 목록"
      ariaLabel="단축키 목록"
      size="xl"
      // ⛔ 예외(이유① — 패널 스크롤 보유): 아래 panelClassName이 `max-h-[85vh]`를 들고 있어
      // base `bodyScroll`의 `max-h-full`과 **같은 property로 부딪힌다**(승자가 Tailwind 출력
      // 순서에 달린다). 푸터가 없고 오버레이 닫기가 살아 있어 패널 스크롤이 **옳은 자리**다 —
      // 헤더만 함께 스크롤되고 닫는 길(오버레이·Esc)이 그 스크롤 영역 밖에 있다.
      bodyScroll={false}
      // 목록이 길어 패널 자체를 뷰포트 안에 가두고 스크롤시킨다(이관 전과 동일 — 헤더도 함께 스크롤).
      panelClassName="max-h-[85vh] overflow-y-auto"
    >
      <div className="space-y-5">
        {SHORTCUTS.map((group) => (
          <section key={group.category}>
            <h3 className="mb-2 text-sm font-semibold text-gray-700">{group.category}</h3>
            <table className="w-full text-sm">
              <tbody>
                {group.items.map((item) => (
                  // 같은 키가 문맥별 두 항목일 수 있어(Tab: 위젯/셀) desc까지 key에 포함
                  <tr key={`${item.keys}:${item.desc}`} className="border-b border-gray-100 last:border-0">
                    <td className="w-2/5 py-1.5 pr-3 align-top">
                      <kbd className="px-1.5 py-0.5 text-xs font-mono bg-gray-100 border border-gray-300 rounded">
                        {item.keys}
                      </kbd>
                    </td>
                    <td className="py-1.5 text-gray-600">{item.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ))}
      </div>
    </Modal>
  );
}
